import { BotBetRepetition } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const botBetRepetitionDictionary = createSimpleDictionary([
    { id: BotBetRepetition.OneBetPerEvent, name: 'dictionaries.botBetRepetition.oneBetPerEvent' },
    { id: BotBetRepetition.OneBetPerEventScore, name: 'dictionaries.botBetRepetition.oneBetPerEventScore' },
]);
